import React from 'react';
import { Badge, Card, Grid, HStack, Link, renderListRows } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

import { Consultation, Document, MenuOption } from 'types';
import { useTranslation } from 'react-i18next';
import { renderDocumentMenuActionButton } from 'pages/CaseDetails/util';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

export interface DocumentsMobileCardProps {
  consultation?: Consultation;
  document: Document;
  options: MenuOption[];
}
export const DocumentsMobileCard: React.FC<DocumentsMobileCardProps> = ({
  consultation,
  document,
  options,
}) => {
  const { t } = useTranslation('case_details_documents');
  const formatLocaleDate = useFormatLocaleDate();

  return (
    <Card width='100%' py={2} px={4} key={document.id}>
      <Grid gridGap={2}>
        <HStack justifyContent='space-between'>
          <Link fontSize='20px'>{document.documentType}</Link>
          {renderDocumentMenuActionButton(consultation, options, document)}
        </HStack>
        {document?.sensitive ? (
          <Badge bgColor={COLOURS.blue[150]} color='black' px={3} width='max-content'>
            {t('sensitive', 'Sensitive')}
          </Badge>
        ) : null}
        {renderListRows([
          {
            label: t('published', 'Published'),
            value: formatLocaleDate(document.datePublished),
          },
          {
            label: t('drawing_number', 'Drawing number'),
            value: document.drawingNumber || '-',
          },
          {
            label: t('document_description', 'Document description'),
            value: document.description || '-',
          },
        ])}
      </Grid>
    </Card>
  );
};
